module.exports = __webpack_public_path__ + "static/media/ev-page-screenshot.fb8b4356.png";